import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  tileMenuContainer: {
    flex: 1,
  },
  tileMenuItemContainer: {
    borderRadius: 30,
    height: 100,
    width: 100,
    alignSelf: 'center',
    justifyContent: 'center',
    alignContent: 'center',
  },
});
